import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { PasswordRecoveryPayload, PasswordResetPayload } from '../store/modules/password-recovery/types';

class PasswordRecoveryService {
  private route = apis.passwordRecover;

  constructor(private api: ApiService) {}

  recover = ({ email }: PasswordRecoveryPayload) => this.api.put<[]>(
    this.route.recover,
    {
      email,
      ...(process.env.REACT_APP_BUILD_ENV === 'development' && { debug_allow_existing_user: true }),
    },
  ).then(() => undefined);

  resend = (email: string) => this.api.put<[]>(
    this.route.recover,
    {
      email,
    },
  );

  reset = (data: PasswordResetPayload) => this.api.put<[]>(this.route.reset, data);
}

export default new PasswordRecoveryService(apiService);
